<template>
  <!-- eslint-disable -->
	<svg
		:height="height" :width="width"
		xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	  viewBox="0 0 1024 354.1" xml:space="preserve"
	>
	<g transform="matrix( 1, 0, 0, 1, 231.6,291.85) ">
		<g transform="matrix( 1, 0, 0, 1, 0,0) ">
			<path fill="#FFFFFF" d="M775.4-115.2c-0.2-20.6-0.6-43.6-1.2-69c-0.5-21.4-0.7-44.4-0.7-69c0-6.7-2.1-12.5-6.4-17.6
				c-4.6-5.2-10.1-7.8-16.4-7.8l-313.9-0.2c-26.2,0-52.3,0.3-78.5,1c-26.2,0.6-52.3,1-78.5,1c-26.2,0-52.3-0.4-78.5-1.2
				c-26.2-0.8-52.3-1.2-78.5-1.2s-52.3,0.7-78.5,2.1S-7.8-275-34-275s-52.3-0.6-78.5-1.7c-26.2-1.3-52.3-1.9-78.5-1.9
				c-6.3,0-11.7,2.6-16.2,7.8c-4.1,4.9-6.2,10.8-6.2,17.6c0,23,0.2,46,0.5,69c0.3,23,0.5,46,0.5,69s-0.5,46-1.4,69s-1.4,46-1.4,69
				c0,6.7,2.4,12.4,7.1,17.4c4.9,5.1,10.6,7.6,17.1,7.6H-34c26.2,0,52.3-0.5,78.5-1.4c26.2-1.1,52.3-1.7,78.5-1.7s52.3,0.3,78.5,1
				c26.2,0.6,52.3,1,78.5,1c26.2,0,52.3,0.2,78.5,0.7c26.2,0.3,52.3,0.5,78.5,0.5l156.9-0.2c26.2,0,52.3-0.2,78.5-0.7
				c26.2-0.6,52.3-1,78.5-1c6.7,0,12.5-2.2,17.6-6.7c5.1-4.6,7.6-10.1,7.6-16.4C775.9-23.2,775.8-69.2,775.4-115.2z"/>
		</g>
		<g transform="matrix( 1, 0, 0, 1, 0,0) ">
			<path fill="#373535" d="M780.2-115.2c0.5-46,0.7-91.9,0.7-137.9c0-7.8-3.1-14.4-9.3-20c-6-5.5-13-8.3-20.9-8.3
				c-31.4,0-62.8,0.2-94.2,0.5c-31.4,0.3-62.8,0.5-94.2,0.5c-62.8,0.5-125.6,0.7-188.3,0.7c-31.4,0-62.8-0.3-94.2-1
				c-31.4-0.8-62.8-1.2-94.2-1.2c-31.4,0-62.8,0.2-94.2,0.5c-31.4,0.3-62.8,0.5-94.2,0.5l-188.3-0.2c-8.1,0-15.1,2.7-21.2,8.1
				c-6.3,5.5-9.5,12.2-9.5,20c0,23,0.8,46,2.4,69c1.4,23,2.1,46,2.1,69c0,46-0.2,91.9-0.7,137.9c0,7.9,2.5,14.5,7.6,19.7
				c5.1,5.4,11.5,8.1,19.3,8.1c31.4,0,62.8,0.2,94.2,0.5c31.4,0.3,62.8,0.5,94.2,0.5s62.8,0.2,94.2,0.5c31.4,0.3,62.8,0.5,94.2,0.5
				c31.4,0,62.8-0.2,94.2-0.5c31.4-0.5,62.8-0.7,94.2-0.7c31.4,0,62.8,0.2,94.2,0.7c31.4,0.3,62.8,0.5,94.2,0.5
				c31.4,0,62.8-0.4,94.2-1.2c31.4-1,62.8-1.4,94.2-1.4c7.9,0,14.6-2.5,20-7.6c5.4-5.2,8.1-11.7,8.1-19.5c0-23,0.2-46,0.7-69
				C780-69.2,780.2-92.2,780.2-115.2 M750.7-273.3c5.2,0,10.1,2.1,14.5,6.2c4.3,4.1,6.4,8.8,6.4,14c0,23-0.3,46-1,69
				c-0.8,23-1.2,46-1.2,69c0,23,0.2,46,0.5,69c0.3,23,0.5,46,0.5,69c0,5.2-2,9.8-5.9,13.8c-4,3.8-8.6,5.7-13.8,5.7
				c-31.4,0-62.8-0.4-94.2-1.2c-31.4-1-62.8-1.4-94.2-1.4c-31.4,0-62.8,0.8-94.2,2.4c-31.4,1.4-62.8,2.1-94.2,2.1
				c-62.8-0.5-125.6-0.7-188.3-0.7C123,43,60.2,42.7-2.6,42.7c-31.4,0-62.8-0.2-94.2-0.5c-31.4-0.5-62.8-0.7-94.2-0.7
				c-5.2,0-9.5-1.8-12.8-5.5c-3.3-3.6-5-8.1-5-13.3c0-23-0.2-46-0.5-69c-0.5-23-0.7-46-0.7-69s0.2-46,0.7-69c0.5-23,0.7-46,0.7-69
				c0-5.4,1.7-10.1,5-14c3.3-4.3,7.5-6.4,12.6-6.4l188.3,1c26.2,0.2,57.5,0.5,94.2,1c28.2,0.3,59.6,0.5,94.2,0.5
				c62.8,0,125.6,0.2,188.3,0.7c31.4,0,62.8-0.3,94.2-1c31.4-0.6,62.8-1,94.2-1c31.4,0,62.8-0.2,94.2-0.5
				C687.9-273.1,719.3-273.3,750.7-273.3z"/>
		</g>
	</g>
	</svg>
</template>

<script>
export default {
  props: {
    height: [Number, String],
    width: [Number, String]
  }
};
</script>
